import type { PatientIntakeStep } from '@shared/patient-intake-status';

type DetermineIfStepIsDisabledParams<TStep extends PatientIntakeStep> = {
  step: TStep;
};

/**
 * Determines if a patient intake step is disabled.
 *
 * - If `step` is `null` or `undefined`, the function returns `true`.
 * - If `step` has an `isDisabled` property, returns the boolean value of `isDisabled`.
 * - Otherwise, returns `false`.
 *
 * This function treats `null`/`undefined` steps as disabled, which is distinct from steps that are explicitly marked as disabled via the `isDisabled` property.
 */
export const determineIfStepIsDisabled = <TStep extends PatientIntakeStep>({
  step,
}: DetermineIfStepIsDisabledParams<TStep>) => !step || ('isDisabled' in step && !!step.isDisabled);
